import { nextfetchdata } from '@/shared/api/nextfetch'

type ProductsResponse = {
	ITEMS: Array<{ ID: number; KOD: string }>
}

type AddProductsToCartParams = {
	productCodes: string[]
}

type AddProductsToCartResult = {
	success: boolean
	addedCount: number
	error?: string
}

const fetchProductsByCodes = async (codes: string[]): Promise<Array<{ ID: number }>> => {
	const filter = {
		KOD: {
			type: '=',
			value: codes
		}
	}

	const filterParam = JSON.stringify(filter)

	const response = await nextfetchdata<ProductsResponse>('index/catalog/products', {
		params: { filter: filterParam, limit: String(codes.length) }
	})

	return response?.ITEMS ?? []
}

export const addProductsToCart = async ({
	productCodes
}: AddProductsToCartParams): Promise<AddProductsToCartResult> => {
	if (!productCodes.length) {
		return { success: false, addedCount: 0, error: 'No product codes provided' }
	}

	try {
		const products = await fetchProductsByCodes(productCodes)

		if (!products.length) {
			return { success: false, addedCount: 0, error: 'Products not found' }
		}

		const cartProducts = products.map(product => ({ ID: product.ID }))

		const response = await nextfetchdata<unknown[]>('basket', {
			method: 'POST',
			params: {
				products: JSON.stringify(cartProducts)
			},
			credentials: 'include'
		})

		if (response) {
			return { success: true, addedCount: products.length }
		}

		return { success: false, addedCount: 0, error: 'Failed to add products to cart' }
	} catch (error) {
		console.log('[addProductsToCart] CATCH error:', error)
		const message = error instanceof Error ? error.message : 'Unknown error'
		return { success: false, addedCount: 0, error: message }
	}
}
